// import { createApp } from 'vue'
import { createPinia } from 'pinia';
import { ViteSSG } from 'vite-ssg';
import VueClickAway from 'vue3-click-away';
import type { I18nOptions } from 'vue-i18n';
import { loadLocalData, loadSessionData } from '@src/utils/common-util';

import App from './App.vue';
import { routesList } from './router';
import AppConfig from '@src/constants';
import { ko, en, setLanguage, setupI18n } from '@src/lang';
// import { initStore } from "@src/stores/store-manager";
// import routes from 'virtual:generated-pages'

// if (typeof window !== "undefined") import("./pwa");

// i18n 설정
let lang = loadSessionData(AppConfig.KEYS.LANG);
if (!lang) {
  setLanguage(Intl.DateTimeFormat().resolvedOptions().locale);
  lang = loadSessionData(AppConfig.KEYS.LANG);
}
const i18nConfig: I18nOptions = {
  legacy: false,
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
  fallbackLocale: 'en',
  locale: lang ? lang : 'en',
  messages: {
    ko,
    en,
  },
};
const i18n = setupI18n(i18nConfig);

export const createApp = ViteSSG(
  App,
  {
    routes: routesList,
    scrollBehavior: (to, from, savedPosition) => {
      // try {
      // document.getElementById("app")?.scrollIntoView({ behavior: "auto" });
      // } catch (e) {
      // console.error(e);
      // }
    },
  },
  ({ app, router, routes, isClient, initialState }) => {
    const pinia = createPinia();
    app.use(pinia);
    app.use(VueClickAway).use(i18n);

    if (import.meta.env.SSR) initialState.pinia = pinia.state.value;
    else pinia.state.value = initialState.pinia || {};

    // router.beforeEach((to, from, next) => {
    //   try {
    //     // const store = initStore();
    //     const user = loadLocalData(AppConfig.KEYS.LOGIN_USER);
    //     const token = loadLocalData(AppConfig.KEYS.LOGIN_TOKEN);

    //     if (to.meta.requireAuth) {
    //       if (!user || !token) {
    //         // router.replace("/admin/login");
    //         window.location.replace('/admin/login');
    //       }
    //     }

    //     // console.log('hihi');
    //     // console.log(to.fullPath.includes('/admin'));
    //     // console.log(to.meta);
    //     // console.log(user, token);

    //     // if (!store.ready)
    //     //   // perform the (user-implemented) store action to fill the store's state
    //     //   store.initialize()
    //   } catch (e) {
    //     console.log(e);
    //   }
    //   try {
    //     next();
    //   } catch (e) {
    //     console.error(e);
    //   }
    // });
  },
);
